import { Controller, useFormContext } from 'react-hook-form';
import { Checkbox } from '@/components/base/checkbox/checkbox';
import type { SignupFormValues } from '../schema';

export const Step16ConsentSponsor = () => {
  const { control } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="consentSponsor"
      render={({ field }) => (
        <label className="flex w-full cursor-pointer items-start gap-4 rounded-2xl border border-gray-200 bg-white p-5 transition-colors hover:border-gray-300">
          <Checkbox
            size="md"
            isSelected={field.value}
            onChange={(next) => field.onChange(next)}
            aria-label="Aceito receber contato dos patrocinadores"
          />
          <span className="flex-1 text-left">
            <span className="block text-[15px] font-semibold text-gray-900">
              Aceito receber contato dos patrocinadores do evento
            </span>
            <span className="mt-1 block text-sm leading-relaxed text-gray-500">
              Patrocinadores e organização podem entrar em contato para apresentar soluções
              relevantes ao seu perfil. Você pode revogar esse consentimento a qualquer momento no
              seu perfil.
            </span>
          </span>
        </label>
      )}
    />
  );
};
